import { defineMessages } from 'react-intl';

export default defineMessages({
  home: {
    id: 'home',
    defaultMessage: 'Home',
  },
  page: {
    id: 'userControl',
    defaultMessage: 'User Control',
  },
  title: {
    id: 'userControl.title',
    defaultMessage: 'Ubah Kata Sandi',
  },

  alertSuccess: {
    id: 'userControl.alert.success',
    defaultMessage: 'Kata sandi berhasil dirubah',
  },
  alertFailed: {
    id: 'userControl.alert.failed',
    defaultMessage: 'Password Anda Salah!',
  },
});
